import { render, staticRenderFns } from "./DetailedTableAguas.vue?vue&type=template&id=30a96876&scoped=true"
import script from "./DetailedTableAguas.vue?vue&type=script&lang=js"
export * from "./DetailedTableAguas.vue?vue&type=script&lang=js"
import style0 from "./DetailedTableAguas.vue?vue&type=style&index=0&id=30a96876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a96876",
  null
  
)

export default component.exports